import * as types from "./mutations-types";

export default {
    [types.SET_LIST_BUDGET](state, budgets) {
        state.budgets = budgets;
    }
};